<template>
    <Card id="mycardcuentas1">
      <template #title>{{ titulo }} <span>{{aYear}}</span><Button type="button" class="ml-2" icon="pi pi-search" @click="toggle" aria-haspopup="true" aria-controls="overlay_panel" /></template>
      <template #content>
        <div id="mychartcuentas1" ref="chartcuentas1"></div>
        <OverlayPanel ref="op" appendTo="body">
            <Dropdown
              v-model="aYear"
              :options="ejercicios"
              id="comboejercicio"
              style="width: 100px"
              class="ml-2"
              @change="getDataChart1()"
          />
          
        </OverlayPanel>
      </template>
    </Card>
</template>

<script>
    //import * as bb from 'billboard.js';
      
    import {
      definiciones
    } from "@/icontaelibs.js";

    import bb, { bar, line } from "billboard.js";
    import * as d3 from 'd3'; // billboard.js depends on D3.js
    import 'billboard.js/dist/billboard.css'; // Import default styles

    export default {
      name: "Chartcuentas",
      props: {
        gYear: String,
        gEjercicios : Array,
        gEmpresaid:Number,
      },
      data() {
        return {
          chartcuentas1: null,
          ejercicios:this.gEjercicios,
          aYear: this.gYear,
          titulo: 'Movimientos de cuenta ',
          empresaid: this.gEmpresaid,
          titulo:'',
          columnsdata : [
            ["x", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            ["data1", "0","0","0","0","0","0","0","0","0","0","0","0"],
            ["data2", 0,0,0,0,0,0,0,0,0,0,0,0]
            
          ],
          

          isLoading : false,
        };
      },
      mounted() {
        this.getDataChart1();
      },
      
    
      beforeUnmount() {
        if (this.chartcuentas1) {
          this.chartcuentas1.destroy(); // Clean up billboard.js instance
        }
      },

      watch: {

        gEmpresaid(){
           this.empresaid = this.gEmpresaid;
        },
        gEjercicios(){
           this.ejercicios = this.gEjercicios; 
        },
        
      },

      methods: {

        toggle(event) {
            this.$refs.op.toggle(event);
        },


        getDataChart1() {
          console.log('this.empresaid');
          console.log(this.empresaid);
          this.isLoading = true;
          //this.columnsdata = [];
          this.$axios
            .get(
                definiciones.URL_API+"/chartscuentas1?p=1&ayear=" +this.aYear+
                "&emp=" +this.empresaid
            )
            .then((response) => {

              console.log(response.data);
              this.columnsdata = response.data;
              this.generateChart();
              this.isLoading = false;
              
            });
        },

        generateChart() {
          console.log('datos....');
          
          //console.log(this.columnsdata[0]);
          // Ensure D3 is available before generating the chart
          if (typeof d3 === 'undefined') {
            console.error('D3.js is not loaded. Please ensure it\'s imported correctly.');
            return;
          }

          this.chartcuentas1 = bb.generate({
              data: {
                x: "x",
                columns: [this.columnsdata[0], this.columnsdata[1], this.columnsdata[2]],
               
                type: bar(), // for ESM specify as: bar()
                labels: true,
                onclick: function(d) {
                      console.log("Clicked bar:", d);
                      console.log("You clicked on: " + d.name + " with value: " + d.value);
                },
                colors: {
                  data1: "#5a189a",
                  data2: "#ff5c8a"
                  
                },
                names: {
                  data1: "Cargos",
                  data2: "Abonos",
                  
                }
              },
              bar: {
                radius: {
                  ratio: 0.1
                }
              },
              axis: {
                x: {
                  type: "category"
                },
                 y: {
                  label: "Importe"
                },

              },

              bindto: this.$refs.chartcuentas1
            });
        },
      },
    };
</script>
<style scoped>


</style>
